/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React, { useState } from 'react';

import { QuickActions, QuickActionsItem } from '@react/react-spectrum/QuickActions';

import classes from './QuickActionWrapper.scss';

const QuickActionWrapper = (props, ref) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocuseed, setIsFocused] = useState(false);

    const quickActions = (
        <QuickActions isOpen={isHovered || isFocuseed} className={classes.root}>
            {props.actions.map(action => (
                <QuickActionsItem
                    key={action.label}
                    label={action.label}
                    icon={action.icon}
                    onClick={action.action}
                    disabled={action.disabled}
                />
            ))}
        </QuickActions>
    );

    let onMouseEnter = () => {
        setIsHovered(true);
    };

    let onMouseLeave = () => {
        setIsHovered(false);
    };

    let onFocus = () => {
        setIsFocused(true);
    };

    let onBlur = () => {
        setIsFocused(false);
    };

    let forwardProps = {
        ...props,
        quickActions,
        onMouseEnter,
        onMouseLeave,
        onFocus,
        onBlur,
        ref
    };

    return React.cloneElement(props.children, { ...forwardProps, ref });
};

export default React.forwardRef(QuickActionWrapper);
